export function pickStrongerColor(colors: Array<string>): string {
  return colors.sort((a, b) => {
    const [r1, g1, b1] = hexToRgb(a)
    const [r2, g2, b2] = hexToRgb(b)

    return r2 - r1 || g2 - g1 || b2 - b1
  })[0]
}

function hexToRgb(hex: string): [number, number, number] {
  const bigint = parseInt(hex.slice(1), 16)
  return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255]
}
